export default class FETCH_API {
  constructor() {

  }

  getRequest(url) {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  postRequest(url, payload) {

    return new Promise((resolve, reject) => {

      this.requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      };

      fetch(url, this.requestOptions)
        .then((response) => response.json())
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          SPN_Console.log(error);
          reject(error);
        });
    });
  }
}
